import script from "./gywmHtml.vue?vue&type=script&setup=true&lang=js"
export * from "./gywmHtml.vue?vue&type=script&setup=true&lang=js"

import "./gywmHtml.vue?vue&type=style&index=0&id=19d71561&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19d71561"]])

export default __exports__